export const RADIO_MANAGER_I18N = {
  favoritesTitle: "Minhas Rádios Favoritas",
  favoritesDetailOne: "1 rádio salva por você",
  favoritesDetailMany: "%d rádios salvas por você",
  loadErrorTitle: "Falha de conexão",
  loadErrorNetwork: "Não foi possível carregar as rádios. Verifique sua internet e tente novamente.",
  loadErrorRetry: "Tentar novamente",
  loadErrorReload: "Recarregar página",
};

export const PROTON_I18N = {
  chat_enabled: true,
  fab_label: "Falar com o PROton",
  title: "PROton",
  subtitle: "online",
  close_aria: "Fechar",
  placeholder: "Pergunte algo… (ex: rádios de rock)",
  send_aria: "Enviar",
  stop_aria: "Parar resposta",
  interrupted: "*interrompido*",
  hint: "IA experimental. Pode errar — confirme dados importantes.",
  welcome:
    "Oi! 👋 Sou o PROton. Posso recomendar rádios, mostrar o que está tocando, ajudar a cadastrar uma rádio e mais. O que precisa?",
  suggestions_title: "Sugestões",
  suggestions: [
    "Sugere uma rádio de rock",
    "Qual rádio tá perto de mim?",
    "Como cadastro minha rádio?",
  ],
  error_network: "Não consegui falar com o PROton. Tenta de novo daqui a pouco.",
  error_rate: "Muitas perguntas em pouco tempo. Aguarde {seconds}s e tente de novo.",
  error_generic: "Algo deu errado. Pode reformular?",
  autoplay_blocked: "O navegador bloqueou o autoplay. Toque em play no player para ouvir.",
  open_link: "Abrir link",
  toast_redirect: "Abrindo nova aba em {seconds}s…",
  toast_open_now: "Abrir agora",
  toast_cancel: "Cancelar",
  status_warming: [
    "Conectando ao PROton…",
    "Preparando resposta…",
    "Só um instante…",
  ],
};

export const RADIO_PAGE_I18N = {
  scheduleHide: "Ocultar programação",
  scheduleShow: "Ver programação",
  scheduleHintCollapsed: "Toque para ver a grade da semana",
  newsEmpty: "Nenhuma notícia no momento.",
  newsPublished: "Publicado",
  newsUpdated: "Atualizado",
  newsLoadMore: "Carregar mais",
  newsErrorLoad: "Não foi possível carregar as notícias.",
  extraLoadFailed: "Não foi possível carregar o conteúdo extra desta rádio.",
  reportSuccess: "Relato enviado com sucesso. Obrigado por avisar!",
  reportErrorSend: "Não foi possível enviar o relato. Tente novamente mais tarde.",
  reportErrorNetwork: "Erro ao enviar o relato. Verifique sua conexão.",
  reportSubmitSending: "Enviando...",
  reportSubmit: "Enviar relato",
  streamUnavailable: "Stream indisponível",
  autoplayBlocked: "O navegador bloqueou o autoplay. Toque em play para ouvir.",
  ariaPlayStream: "Reproduzir stream",
  ariaPause: "Pausar",
  ariaPlay: "Reproduzir",
  ariaLoading: "Carregando",
  favoriteRemoved: "Removida dos favoritos",
  favoriteAdded: "Adicionada aos favoritos",
  favoriteErrorRemove: "Não foi possível remover dos favoritos.",
  favoriteErrorRemoveNetwork: "Falha de rede ao remover dos favoritos.",
  favoriteErrorAdd: "Não foi possível adicionar aos favoritos.",
  favoriteErrorAddNetwork: "Falha de rede ao adicionar aos favoritos.",
  favoriteSyncLogin: "Faça login para sincronizar seus favoritos.",
  programNow: "No ar",
  stationRequestSending: "Enviando solicitação…",
  stationRequestSubmit: "Enviar solicitação",
  stationRequestSuccess: "Solicitação enviada. Nossa equipe entrará em contato em breve.",
  stationRequestError: "Não foi possível enviar a solicitação. Tente novamente.",
  stationRequestNetwork: "Falha de rede ao enviar a solicitação.",
  stationRequestLoginRequired: "Faça login para continuar com a solicitação.",
  stationRequestValidation: "Preencha os campos obrigatórios com dados válidos.",
  stationRequestRateLimited:
    "Você acabou de enviar uma solicitação para esta rádio. Aguarde {seconds} segundos antes de tentar de novo.",
};

export function applyWindowGlobals() {
  window.APPRADIO_PUBLIC_BASE = "";
  window.RADIO_MANAGER_I18N = RADIO_MANAGER_I18N;
  window.PROTON_CHAT_URL = "/ajax/ajax-proton-chat.php";
  // canal do player do PROton: servido por este backend (ws:// em http, wss:// em https)
  const protonBase = (window as { __RP_ORIGINS__?: { protonWs?: string } }).__RP_ORIGINS__?.protonWs;
  window.PROTON_WS_URL = `${protonBase || `${window.location.protocol === "https:" ? "wss:" : "ws:"}//${window.location.host}`}/api/proton/ws`;
  window.PROTON_I18N = PROTON_I18N;
  window.radioPageI18n = RADIO_PAGE_I18N;
}

export function ensurePageCss(href: string) {
  if (document.querySelector(`link[data-rp-css="${href}"]`) || document.querySelector(`link[href="${href}"]`)) {
    return;
  }
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.dataset.rpCss = href;
  document.head.appendChild(link);
}

export function readCookie(name: string): string {
  const parts = document.cookie ? document.cookie.split(";") : [];
  for (const raw of parts) {
    const part = raw.trim();
    if (part.indexOf(name + "=") === 0) {
      try {
        return decodeURIComponent(part.substring(name.length + 1));
      } catch {
        return part.substring(name.length + 1);
      }
    }
  }
  return "";
}

export function slugFromTitle(title: string): string {
  let s = title || "";
  if (typeof s.normalize === "function") {
    s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
  return s
    .replace(/\./g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80)
    .replace(/-+$/g, "");
}

export function readPageData<T = Record<string, unknown>>(): T | null {
  if (typeof document === "undefined") return null;
  const el = document.getElementById("rp-page-data");
  if (!el || !el.textContent) return null;
  try {
    return JSON.parse(el.textContent) as T;
  } catch {
    return null;
  }
}

export type HeadMetaOptions = {
  title: string;
  description?: string | null;
  canonical?: string | null;
  robots?: string | null;
  ogTitle?: string | null;
  ogDescription?: string | null;
  ogUrl?: string | null;
  ogImage?: string | null;
  ogSiteName?: string | null;
};

function setMetaTag(attr: "name" | "property", key: string, value: string | null | undefined) {
  const sel = `meta[${attr}="${key}"]`;
  const existing = document.querySelector(sel);
  if (value === null) {
    existing?.parentNode?.removeChild(existing);
    return;
  }
  if (value === undefined) return;
  if (existing) {
    existing.setAttribute("content", value);
    return;
  }
  const m = document.createElement("meta");
  m.setAttribute(attr, key);
  m.setAttribute("content", value);
  document.head.appendChild(m);
}

export function syncHeadMeta(opts: HeadMetaOptions) {
  document.title = opts.title;
  if (opts.canonical !== undefined) {
    const can = document.querySelector('link[rel="canonical"]');
    if (opts.canonical === null) {
      can?.parentNode?.removeChild(can);
    } else if (can) {
      can.setAttribute("href", opts.canonical);
    } else {
      const link = document.createElement("link");
      link.rel = "canonical";
      link.href = opts.canonical;
      document.head.appendChild(link);
    }
  }
  setMetaTag("name", "description", opts.description);
  setMetaTag("name", "robots", opts.robots);
  if (opts.ogTitle === null) {
    document.querySelectorAll('meta[property^="og:"]').forEach((el) => el.parentNode?.removeChild(el));
    return;
  }
  setMetaTag("property", "og:title", opts.ogTitle);
  setMetaTag("property", "og:description", opts.ogDescription);
  setMetaTag("property", "og:url", opts.ogUrl);
  setMetaTag("property", "og:image", opts.ogImage);
  setMetaTag("property", "og:site_name", opts.ogSiteName);
}
